
import dynamicIcon from '~/mixins/dynamic-icon';

export default {
    mixins: [dynamicIcon],
    props: {
        width: {
            type: String,
            default: '16'
        },
        height: {
            type: String,
            default: '16'
        },
        pathStyle: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        defaultPathStyle() {
            return {
                fill: 'var(--text-colors-body-text)',
                stroke: 'none'
            };
        }
    }
};
